export default __webpack_public_path__ + "static/media/ji-woon.7146378f.png";